import React from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import PartnershipImg from "../../assets/images/partnership/buldingTogether.png"

import GovermentImg from "../../assets/images/partnership/goverment.svg"
import HospitalImg from "../../assets/images/partnership/hospital.svg"
import InsuranceImg from "../../assets/images/partnership/insurance.svg"



const Partnerships=()=>{
    return(
        <>
        <div className="partnershipsPage">
            <Navbar />
            <div className="partnershipSection">
                <div className="container">
                    <div className="partnerShipHeader">
                        <h1>Partnerships</h1>
                        <p>Collaborating with governments, healthcare providers, and organizations to build a smarter health infrastructure.</p>
                    </div>
                    <div className="BuildingTogether">
                        <div className="buildingImg">
                            <img src={PartnershipImg} alt="Building Together" />
                        </div>
                        <div className="buildingContent">
                            <h4>Building Together</h4>
                            <p>Strengthening the health ecosystem through strategic alliances.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="partnerBenefitsSection">
                <div className="container">
                    <div className="row">
                        <div className="col-xs-12 col-md-4">
                            <div className="benefitCard">
                                <div className="icon">
                                    <img src={GovermentImg} />
                                </div>
                                <div className="cardDetails">
                                    <h5>Government</h5>
                                    <p>Partnering with state and central health ministries to implement large-scale digital health missions and public health monitoring systems.</p>
                                    <ul>
                                        <li>Policy Implementation</li>
                                        <li>Disease Surveillance</li>
                                        <li>Resource Allocation</li>
                                    </ul>
                                    <a href="#">Parter as Gov </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-12 col-md-4">
                            <div className="benefitCard">
                                <div className="icon">
                                    <img src={HospitalImg} />
                                </div>
                                <div className="cardDetails">
                                    <h5>Hospitals</h5>
                                    <p>Empowering private and public hospitals with AI-driven management systems to improve patient care and operational efficiency.</p>
                                    <ul>
                                        <li>Smart OPD Management</li>
                                        <li>AI Diagnostics</li>
                                        <li>Digital Records</li>
                                    </ul>
                                    <a href="#">Parter as Hospital</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-12 col-md-4">
                            <div className="benefitCard">
                                <div className="icon">
                                    <img src={InsuranceImg} />
                                </div>
                                <div className="cardDetails">
                                    <h5>Insurance</h5>
                                    <p>Enabling seamless claims processing and fraud detection for insurance providers through real-time data integration.</p>
                                    <ul>
                                        <li>Faster Claims</li>
                                        <li>Fraud Prevention</li>
                                        <li>Risk Assessment</li>
                                    </ul>
                                    <a href="#">Partner as Insurer</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <div className="readyCollaborateSection">
                <div className="container">
                   <div className="readyCollaborateSectionContent">
                        <h3>Ready to Collaborate?</h3>
                        <p>Join us in our mission to transform healthcare delivery in India. Let's create a healthier future together.</p>
                        <a href="#" className="collaborateBtn">Become a Partner</a>
                   </div>
                </div>
            </div>


        </div>
        <Footer />
        </>
    );
}   

export default Partnerships;